import { FC } from "react";

export const UiSectionH3: FC<{
  title: string;
}> = ({ title }) => {
  return (
    <h3 className="mb-4 text-base font-semibold text-[#232323] sm:mb-8 sm:text-[1.25rem] sm:leading-[1.625rem]">
      {title}
    </h3>
  );
};
